const dateFmt = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

/**
 * Whether a title (or a season) isn't out yet, so no streams can exist: its release or first
 * air date is still to come, or, when only the year is known, that year is. `on` is the date to
 * show, or the year.
 */
export function comingSoon(m: {
  releaseDate?: string | null;
  firstAirDate?: string | null;
  year?: number | null;
}): { on: string | null } | null {
  const iso = m.releaseDate || m.firstAirDate;
  if (iso) {
    const t = Date.parse(iso);
    return !Number.isNaN(t) && t > Date.now() ? { on: dateFmt.format(t) } : null;
  }
  return m.year && m.year > new Date().getFullYear() ? { on: String(m.year) } : null;
}
